module.exports = __webpack_public_path__ + "img/res3-m.46384a6f.png";